import { useAccountSnapshot } from "@/stores/account.store";
import { Navigate } from "react-router-dom";
import { JSX } from "react";
import LoadingPage from "@/pages/utils/loading.page";

const PrivatePage = (props: { children: JSX.Element }) => {
  const { isLoading, isLogged } = useAccountSnapshot();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isLogged) {
    return <Navigate to="/login" />;
  }

  if (isLogged) {
    return props.children;
  }
};

export default PrivatePage;
